<template>
  <div class="container">
    <div class="row">
      <div class="col col-login mx-auto">
        <div class="text-center mb-6">
        </div>
        <!-- <button type="button" class="btn btn-primary btn-block" @click="submitLogin">Sign In</button> -->
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService'

export default {
  name: 'LoginPage',
  created () {
    AuthService.login()
  },
  data () {
    return {
    }
  },
  methods: {
    submitLogin () {
      AuthService.login()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/LoginPage.vue